export const SET_COACHMARK_REFS = 'SET_COACHMARK_REFS';

export default (state, action) => {
  const { type, payload = {} } = action;

  switch (type) {
    case SET_COACHMARK_REFS: {
      return {
        ...state,
        coachmarkRefs: {
          ...state.coachmarkRefs,
          coachmarkStock: {
            ...state.coachmarkRefs?.coachmarkStock,
            ...payload.coachmarkStock,
          },
        },
      };
    }
    default:
      return state;
  }
};
